<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <template v-if="searchShow">
            <div class="item-son">
              <el-input
                  v-model="listParams.searchKey"
                  placeholder="搜索关键词"
                  @keyup.enter.native="queryTableData"
              ></el-input>
            </div>
            <!-- <div class="item-son">
              <el-select
                  v-model="listParams.paymentType"
                  clearable
                  filterable
                  placeholder="请选择支付类型"
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in payTypeData"
                    :key="index"
                    :label="item.name"
                    :value="item.paymentType"
                ></el-option>
              </el-select>
            </div> -->
            <!-- <div class="item-son">
              <el-select
                  v-model="listParams.companyId"
                  clearable
                  filterable
                  placeholder="请选择主体"
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in companyData"
                    :key="index"
                    :label="item.name"
                    :value="item.companyId"
                ></el-option>
              </el-select>
            </div> -->
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  placeholder="请选择状态"
                  style="width: 120px"
              >
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button type="primary" @click="queryTableData"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </template>
          <div class="item-son" v-if="searchShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%;"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column
            align="center"
            fixed
            label="序号"
            type="index"
            width="100"
        >
          <template slot-scope="scope">
                <span>{{
                    (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                  }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mchId" label="商户ID" align="center">
        </el-table-column>
        <el-table-column prop="mchName" label="商户名称"  width="220" align="center">
        </el-table-column>
        <el-table-column prop="mchType" label="商户类型" align="center">
        </el-table-column>
        <!-- <el-table-column
            prop="paymentType"
            label="支付类型"
            width="120"
            align="center">
          <template slot-scope="scope">
            {{!isEmpty(scope.row.paymentTypeVo) ? scope.row.paymentTypeVo.name : "" }}
          </template>
        </el-table-column>
        <el-table-column
            prop="companyVo"
            label="主体"
            width="150"
            align="center"
        >
          <template slot-scope="scope">
            {{ !isEmpty(scope.row.companyVo) ? scope.row.companyVo.name : "" }}
          </template> 
        </el-table-column>-->
        <el-table-column prop="baseUrl" label="商户地址" width="280"  align="center">
        </el-table-column>
        <el-table-column prop="webhookId" label="webhookId"  align="center">
        </el-table-column>
        
        <!-- <el-table-column prop="descr" label="说明" width="200" align="center">
        </el-table-column>

        <el-table-column prop="ctime" label="时间" width="200" align="center">
        </el-table-column> -->

        <el-table-column prop="code" v-if="userInfo && userInfo.operateStatus==1" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <template v-if="numType">
              <el-switch
                  :disabled="statusShow"
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeSwitch(scope.row)"
              >
              </el-switch>
            </template>
            <template v-else>
              <el-switch
                  :disabled="statusShow"
                  :value="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="operationShowTime"
              >
              </el-switch>
            </template>
          </template>
        </el-table-column>

        <el-table-column v-if="editShow && deleteShow && complaintShow && userInfo && userInfo.operateStatus==1" label="操作" width="280" fixed="right"
                         align="center" min-width="200">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleClick('edit', scope.row)"
                type="primary"
                plain
                v-if="editShow"
            >编辑
            </el-button
            >
            <template v-if=" complaintShow && scope.row.paymentTypeVo && scope.row.paymentTypeVo.paymentType=='WECHAT'">
              <el-button
                  size="mini"
                  @click="noticeOfComplaint(scope.row)"
                  type="success"
                  plain
              >投诉通知
              </el-button>
            </template>
            <el-button
                size="mini"
                @click="handleDelete(scope.row)"
                type="danger"
                plain
                v-if="numType && deleteShow"
            >删除
            </el-button
            >
            <el-button
                v-if="!numType && deleteShow"
                size="mini"
                @click="operationShowTime"
                type="danger"
                plain
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageNo"
            :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="商户信息"
        :visible.sync="dialogVisible"
        width="760px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="150px"
        >
        <el-form-item prop="mchType" label="商户类型">
          <el-select
            v-model="params.mchType"
            clearable
            placeholder="请选择商户类型"
            filterable
          >
            <el-option
              v-for="(item, index) in mchListData"
              :key="index"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称" prop="mchName">
          <el-input
              placeholder="请填写商户名称"
              v-model="params.mchName"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户ID" prop="mchId">
          <el-input
              placeholder="请填写商户ID"
              v-model="params.mchId"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户KEY/私钥" prop="privateKey">
          <el-input
              placeholder="请填写商户KEY/私钥"
              v-model="params.privateKey"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户公钥" prop="publicKey">
          <el-input
              placeholder="请填写商户公钥"
              v-model="params.publicKey"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户地址" prop="baseUrl">
          <el-input
              placeholder="请填写商户地址"
              v-model="params.baseUrl"
          ></el-input>
        </el-form-item>
        <el-form-item label="webhookId" prop="webhookId">
          <el-input
              placeholder="请填写商户公钥"
              v-model="params.webhookId"
          ></el-input>
        </el-form-item>
          <!-- <el-row type="flex">
            <el-col>
              <el-form-item prop="paymentType" label="支付类型">
                <el-select
                    v-model="params.paymentType"
                    clearable
                    placeholder="请选择支付类型(新增后不可修改)"
                    style="width: 100%"
                    filterable
                    @change="changePayType"
                    :disabled="clickType == 'edit'"
                >
                  <el-option
                      v-for="(item, index) in payTypeData"
                      :key="index"
                      :label="item.name"
                      :value="item.paymentType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="商户ID" prop="mchId">
                <el-input
                    placeholder="请填写商户ID(新增后不可修改)"
                    v-model="params.mchId"
                    :disabled="clickType == 'edit'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col>
              <el-form-item label="商户名称" prop="mchName">
                <el-input
                    placeholder="请填写商户名称"
                    v-model="params.mchName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item prop="companyId" label="主体">
                <el-select
                    v-model="params.companyId"
                    clearable
                    filterable
                    placeholder="请选择主体(新增后不可修改)"
                    style="width: 100%"
                    @change="changeCommercial"
                    :disabled="clickType == 'edit'"
                >
                  <el-option
                      v-for="(item, index) in companyData"
                      :key="index"
                      :label="item.name"
                      :value="item.companyId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="说明">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入说明"
                v-model="params.descr"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="支付方式编码">
            <el-input
                placeholder="请输入支付方式编码"
                v-model="params.paymentMethodCode"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="商户秘钥" prop="privateKey">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请填写商户秘钥"
                v-model="params.privateKey"
            ></el-input>
          </el-form-item>
          <el-form-item label="baseUrl">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请填写三方支付平台根域名"
                v-model="params.baseUrl"
            ></el-input>
          </el-form-item>
          <el-form-item label="webhookId">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请填写支付回调webhookid(paypal使用)"
                v-model="params.webhookId"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="params.paymentType == 'WECHAT'" label="v3秘钥" prop="apiv3Key">
            <el-input
                placeholder="请填写v3秘钥"
                v-model="params.apiv3Key"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="params.paymentType == 'WECHAT'" label="证书序列号" prop="serialNo">
            <el-input
                placeholder="请填写证书序列号"
                v-model="params.serialNo"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="公钥"
          >
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请填写公钥"
                v-model="params.publicKey"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
                   v-if="numType"
        >提 交</el-button
        >
        <el-button v-else size="medium" type="primary" @click="operationShowTime"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 投诉通知 -->
    <el-dialog
        title="投诉通知"
        :visible.sync="complaintDialogVisible"
        width="660px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form" v-if="complaintInfo">
        <div class="comput_item" v-if="complaintInfo.paymentTypeVo">
          <span>类型：</span>
          <span>{{complaintInfo.paymentTypeVo.name}}</span>
        </div>
        <div class="cpmout_box_infos">
          <div  class="comput_item" style="margin-right: 20px">
            <span>商户ID：</span>
            <span>{{complaintInfo.mchId}}</span>
          </div>
          <div class="comput_item">
            <span>商户名称：</span>
            <span>{{complaintInfo.mchName}}</span>
          </div>
        </div>
        <div class="comput_item" v-if="complaintInfo.companyVo">
          <span>主体：</span>
          <span>{{complaintInfo.companyVo.name}}</span>
        </div>
        <div class="comput_item" style="width: 480px">
          <span>* 通知地址：</span>
          <el-input style="width: 320px" v-model="complaintInfo.complaintNotifyUrl"></el-input>
        </div>
        <div class="comput_item">
          <span>* 通知状态：</span>
          <el-switch
              v-model="complaintInfo.complaintNotifyStatus"
              :active-value="1"
              :inactive-value="0"
          >
          </el-switch>
        </div>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button v-if="numType" size="medium" type="primary" @click="notifyEdit">提 交</el-button>
        <el-button v-else size="medium" type="primary" @click="operationShowTime">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="支付说明"
        :visible.sync="payDialogVisible"
        width="660px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form" v-if="payComplaintInfo">
        <div class="comput_item" v-if="payComplaintInfo.paymentTypeVo">
          <span>类型：</span>
          <span>{{payComplaintInfo.paymentTypeVo.name}}</span>
        </div>
        <div class="cpmout_box_infos">
          <div  class="comput_item" style="margin-right: 20px">
            <span>商户ID：</span>
            <span>{{payComplaintInfo.mchId}}</span>
          </div>
          <div class="comput_item">
            <span>商户名称：</span>
            <span>{{payComplaintInfo.mchName}}</span>
          </div>
        </div>
        <div class="comput_item" v-if="payComplaintInfo.companyVo">
          <span>主体：</span>
          <span>{{payComplaintInfo.companyVo.name}}</span>
        </div>
        <div class="comput_item_box_changs">
          <div class="left_box_infos">
            <div class="cou_infos" @click="delectChangBox(item,index)" v-for="(item,index) in bizIds" :key="index">{{item.domainBizAddress}}<i style="margin-left: 5px" class="el-icon-remove-outline"></i></div>
          </div>
          <div class="box_pay_chses">
            <i class="el-icon-d-arrow-left" ></i>
          </div>
          <div class="left_box_infos">
            <div class="cou_infos" @click="addChangBox(item,index)" v-for="(item,index) in payDomainList" :key="index">{{item.domainBizAddress}}<i style="margin-left: 5px" class="el-icon-circle-plus-outline"></i></div>
          </div>
        </div>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button v-if="numType" size="medium" type="primary" @click="saveInfo">保 存</el-button>
        <el-button v-else size="medium" type="primary" @click="operationShowTime">保 存</el-button>
      </span>
    </el-dialog>
    <operation-confirmation @closeOperation="publicMethios"
                            :operationVisible="operationVisible"></operation-confirmation>
  </div>
</template>
<script>
import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";

import {isEmpty} from "@utils/tools/index";
import OperationConfirmation from "../../components/OperationConfirmation";

export default {
  components: {OperationConfirmation},
  data() {
    return {
      // recallStatus:"0",
      complaintDialogVisible: false,
      complaintInfo:{},
      payDialogVisible:false,
      payComplaintInfo:{},
      isEmpty,
      listParams: {},
      params: {},
      tableData: [],
      payTypeData: [],
      companyData: [],
      mchListData: [],
      domainNameData: [],
      publicKey: false,
      disabled: true,
      dialogVisible: false,
      clickType: "",
      total: 0,
      PAGE_SIZE,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      rules: {
        // mchType: [
        //   {required: true, message: "请选择商户类型", trigger: "change"},
        // ],
        // publicKey: [
        //   {required: true, message: "请填写公钥", trigger: "change"},
        // ],
        // mchId: [{required: true, message: "请填写商户ID", trigger: "change"}],
        // mchName: [
        //   {required: true, message: "请填写商户名称", trigger: "change"},
        // ],
        // companyId: [
        //   {required: true, message: "请选择主体", trigger: "change"},
        // ],
        // privateKey: [
        //   {required: true, message: "请填写商户秘钥", trigger: "change"},
        // ],
        // domainBizId: [
        //   {required: true, message: "请选择回调地址", trigger: "change"},
        // ],
        // domainUri: [
        //   {required: true, message: "请填写接口地址", trigger: "change"},
        // ],

        // apiv3Key: [
        //   {required: true, message: "请填写微信apiv3秘钥", trigger: "change"},
        // ],
        // serialNo: [
        //   {required: true, message: "请填写证书序列号", trigger: "change"},
        // ],

      },
      operationVisible: false,
      numType: false,
      bizIds:[],
      oldBizIds:[],
      payDomainList:[],

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow:true,
      searchShow: false,
      complaintShow:false

      
    };
  },
  created() {
    if (window.sessionStorage.getItem('operationKey')) {
      this.numType = true
    }
    this.queryTableData();
    this.payTypeList(); //获取支付类型
    this.companyList(); //获取主体列表
    this.domainNameList(); //回调地址
    this.getPayDomain()
    this.getPermissionButtonList()
    this.getMchList()
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'pay:mch:info:complaint') {
            this.complaintShow = true
          }
          if (item.code == 'pay:mch:info:query') {
            this.searchShow = true
          }
          if (item.code == 'pay:mch:info:add') {
            this.addShow = true
          }
          if (item.code == "pay:mch:info:delete") {
            this.deleteShow = true
          }
          if (item.code == "pay:mch:info:edit") {
            this.editShow = true
          }
          if(item.code == "pay:mch:info:status"){
            this.statusShow = false
          }
        })
      }
    },

    async saveInfo(){
      const {data: resData} = await this.$post(
          "/payment/mch/domain/biz/ids",{
            domainBizIds:this.oldBizIds,
            paymentMchid:this.payComplaintInfo.paymentMchId
          },
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.queryTableData();
      this.payDialogVisible = false;
      this.clearStore()
    },
    delectChangBox(e,index){
      this.payDomainList.push(e)
      this.oldBizIds.splice(index,1)
      this.bizIds.splice(index,1)
    },
    addChangBox(e,index){
      this.bizIds.push(e)
      this.oldBizIds.push(e.domainBizId)
      this.payDomainList.splice(index,1)
    },
    async getPayDomain(e) {
      const {data: resData} = await this.$get(
          "/domain/biz/list?paging=false&bizType=pay",
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.payDomainList = resData.data
    },
    async payDomainName(e){
      const {data: resutData} = await this.$get(
          "/payment/mch/domain/biz/ids?paymentMchId="+e.paymentMchId,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resutData.result != 200) return;
      if(resutData.data){
        let arr = []
        resutData.data.map(item=>{
          this.payDomainList.map(items=>{
            if(item==items.domainBizId){
              arr.push(items)
            }
          })
        })
        this.bizIds = arr
        this.oldBizIds = resutData.data
        this.payDomainList.map((items,indexs)=>{
          resutData.data.map((item,index)=>{
            if(item==items.domainBizId){
              this.payDomainList.splice(indexs,1)
            }
          })
        })
      }
      const {data: resData} = await this.$get(
          "/payment/mch/info/"+e.paymentMchId,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.payComplaintInfo = resData.data
      this.payDialogVisible = true
    },
    async notifyEdit(){
      if(!this.complaintInfo.complaintNotifyUrl){
        this.$message.error('请填写通知地址')
      }else {
        const {data: resData} = await this.$post(
            "/payment/mch/complaint/notify",{
                complaintNotifyStatus:this.complaintInfo.complaintNotifyStatus,
                complaintNotifyUrl:this.complaintInfo.complaintNotifyUrl,
                paymentMchId:this.complaintInfo.paymentMchId,
            },
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.queryTableData();
        this.complaintDialogVisible = false;
        this.$message.success("添加成功!");
        this.clearStore()
      }
    },
    async noticeOfComplaint(e) {
      const {data: resData} = await this.$get(
          "/payment/mch/info/"+e.paymentMchId,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.complaintInfo = resData.data
      this.complaintDialogVisible = true
    },
    //查询商户类型列表
    async getMchList(){
      const {data: resData} = await this.$get(
          "/app/mch/list/types"
      );
      this.mchListData = resData.data
    },
    //清楚缓存数据，重启密码验证
    clearStore() {
      window.sessionStorage.removeItem('operationKey')
      this.numType = false
    },
    //关闭 5分钟后清楚数据
    publicMethios(e) {
      this.operationVisible = false
      if (e == 'open') {
        this.numType = true
        setTimeout(() => {
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        }, 300000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e) {
      this.operationVisible = true
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("payment/mch/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page ? resData.page.count : resData.data.length;
    },
    /**
     * 修改商户状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `payment/mch/info/status/${b.paymentMchId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
      this.clearStore()
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "edit") {
        //编辑
        const {data: resData} = await this.$get(
            `payment/mch/info/${row.paymentMchId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
      }
    },

    /**
     * 编辑
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add" || this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "/payment/mch/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            let temp = {
              companyId: this.params.companyId,
              descr: this.params.descr,
              paymentMethodCode: this.params.paymentMethodCode,
              mchType: this.params.mchType,
              mchId: this.params.mchId,
              mchName: this.params.mchName,
              paymentMchId: this.params.paymentMchId,
              paymentType: this.params.paymentType,
              privateKey: this.params.privateKey,
              publicKey: this.params.publicKey,
              status: this.params.status,
              apiv3Key: this.params.apiv3Key,
              serialNo: this.params.serialNo,
              webhookId:this.params.webhookId,
              baseUrl:this.params.baseUrl
            };

            const {data: resData} = await this.$put(
                "/payment/mch/info",
                temp,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }

        });
      });
      this.clearStore()
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/payment/mch/info/${row.paymentMchId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        this.queryTableData();
        this.$message.success("删除成功!");
      });
      this.clearStore()
    },
    /**
     * 获取支付类型
     */
    async payTypeList() {
      const {data: resData} = await this.$get(
          "/payment/type/list",
          {},
          {
            headers: {
              isLoading: true,
            },
          }
      );

      if (resData.result != 200) return;
      this.payTypeData = resData.data;
    },

    /**
     * 主体列表（企业列表）
     */
    async companyList() {
      this.loading = true;

      const {data: resData} = await this.$get("/company/list", {
        params: {
          paging: false
        }
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.companyData = resData.data;
    },

    /**
     * 回调地址列表（业务域名列表）
     */
    async domainNameList() {
      this.loading = true;

      const {data: resData} = await this.$get("/domain/biz/list", {
        params: {
          paging: false
        }
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.domainNameData = resData.data;
    },
    /**
     *
     */
    changePayType(val) {
      if (val == "ALIPAY") {
        this.publicKey = true;
      } else {
        this.publicKey = false;
      }
    },
    changeCommercial(val) {
      if (val !== "") this.disabled = false;
    },
    changeUrl(val) {
      this.domainBizId = val;
    },

    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped="">
  .comput_item{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 14px;
    width: 300px;
  }
  .cpmout_box_infos{
    display: flex;
    align-items: center;
  }
  .comput_item_box_changs{
    display: flex;
    cursor: pointer;
    align-items: center;
    .left_box_infos{
      width:40%;
      height: 400px;
      overflow-y: scroll;
      border: 1px solid #959595;
      padding: 10px;
      .cou_infos{
        margin-bottom: 10px;
      }
    }
    .box_pay_chses{
      margin: 0 10px;
    }
  }
</style>
